var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49463 18.5C14.4652 18.5 18.4946 14.4706 18.4946 9.5C18.4946 4.52944 14.4652 0.5 9.49463 0.5C4.52407 0.5 0.494629 4.52944 0.494629 9.5C0.494629 14.4706 4.52407 18.5 9.49463 18.5ZM4.49463 10.5H14.4946V8.5H4.49463V10.5Z",
    fill: "#5664D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c5d92c7a8fe32720e47c78f0780b1c17.svg";
export { ForwardRef as ReactComponent };